import React from 'react'
import ProductionJob from '../components/production/productionJob/ProductionJob'


export default function () {
  return (
    <ProductionJob />
  )
}
